var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"h-t-admin-page"},[(_vm.quickAccess === 'top')?_c('quick-access'):_vm._e(),_vm._t("default"),(_vm.quickAccess === true || _vm.quickAccess === 'bottom')?_c('quick-access',{staticClass:"mt-4 mt-sm-8"}):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }